import React, {Component, Fragment} from "react";
import {
  Button,
  Col,
  FormGroup, FormText,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane
} from "reactstrap";
import {formsDataUpdater, formsUpdater, getFormFieldValue} from "../../Applications/shared/shared";
import classnames from 'classnames';
import {EventClient} from "../../../util/eventClient";
import {deleteData, getData, postData} from "../../../api/doLogin";
import {MakeDialog} from "../../../components/Shared/MakeDialog";
import './lmsentry.css';
import NotesTab from "../views/NotesTab";
import DocumentsTab from "../views/DocumentsTab";
import {getLMSStatusList} from "../../../constants/LMSConstants";
import {hasPermission, RequiredPermission} from "../../../api/permissionHelper";
import LMSFolderSelection from "./LMSFolderSelection";
import IntakesTab from "../views/IntakesTab";
import LinkedLeadsTab from "../views/LinkedLeads";
import {toast} from "react-toastify";
import {checkPerms, RequiredPermissions} from "../../../api/permissions";
import RecordingsTab from "../views/RecordingsTab";

export default class LMSEntryEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      lmsId: null,
      appttypes: [],
      dataLoaded: false,
      formData: {}, // Left off here. Make edit be ID and retrieve Entry data with appt Constants.
      noteData: {},
      sweepstakes: [],
      url: null,
      edit: [],
      notes: [],
      documents: [],
      intakes: [],
      recordings: [],
      linkedLeads: [],
      showLMSPicker: false,
      activeTab: "1",
      hideButtons: false,
      showFolderSelection: false,
      highlightErrors: {}, // This is for highlighting errors in the form
      ets_date: "",
    };
    // console.log("Loaded fileeditor");
  }

  componentWillMount() {
    EventClient.on("LMS_ENTRY_EDIT", (lmsId) => this.setState({
      lmsId: lmsId,
      open: true,
      dataLoaded: false,
      activeTab: "1"
    }, () => {
      this.getLMSEntry(lmsId);
    }), "LMSEntryEditor");
    EventClient.on("LMS_ENTRY_ADD", (options) => this.setState({
      lmsId: 0,
      open: true,
      formData: {
        fid: options.fid,
        folderPath: options.folderPath,
        homeemail: options.homeemail || "",
        homephone: options.homephone || "",
        cellphone: options.cellphone || "",
        dcStatus: "100",
        status: "1"
      },
      noteData: {},
      sweepstakes: [],
      url: null,
      edit: [],
      notes: [],
      documents: [],
      intakes: [],
      recordings: [],
      linkedLeads: [],
      showLMSPicker: false,
      dataLoaded: true,
      hideButtons: false,
      showFolderSelection: false,
      activeTab: "1"
    }), "LMSEntryEditorAdd");
    // EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    // EventClient.on(this.props.deleteEvent, () => this.deleteExternal(), this.props.eventName);

  }

  componentWillUnmount() {
    EventClient.off("LMS_ENTRY_EDIT", () => {
    }, "LMSEntryEditor");
    EventClient.off("LMS_ENTRY_ADD", () => {
    }, "LMSEntryEditorAdd");
    // EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    // EventClient.off(this.props.deleteEvent, () => this.deleteExternal(), this.props.eventName);
  }

  saveExternal() {
    // console.log(this.state.formData);
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave(resp);
      }
    })
  }

  deleteExternal() {
    // deleteData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}`, {}, this.props.token)
    //   .then((data) => {
    //     if (data.status === "Success") {
    //       EventClient.emit("BRIEFCASE_REFRESH", this.props.folderId || 0);
    //       EventClient.emit("NAVIGATE", `/briefcase/${this.props.folderId || 0}`);
    //     }
    //   }).catch((error) => {
    //   console.log(error);
    // });
  }

  saveInternval() {

  }

  downloadFile() {
    if (!this.props.edit || this.props.edit === 0) return;
    const self = this;
    // getData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/download`, {}, this.props.token)
    //   .then((data) => {
    //     if (data.status === "Success") {
    //       // console.log(data.data);
    //       if (data.data.url !== null) {
    //         window.open(data.data.url, "_blank");
    //       } else {
    //         toast.error("Could not download");
    //       }
    //     } else {
    //       toast.error("Could not download");
    //     }
    //   }).catch((error) => {
    //   console.log(error);
    //   toast.error("Could not download");
    // });
  }

  getLMSEntry(lmsId) {
    // console.log(this.props.edit);
    if (!lmsId || lmsId === 0 || lmsId === "0") return;
    const self = this;
    getData(`lms/${lmsId || 0}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          console.log(data.data);
          let responseStateData = {
            notes: data.data.notes,
            // formData: data.data.file,
            formData: data.data.lead, // need to edit the lead data
            sweepstakes: data.data.sweepStakes,
            documents: data.data.documents,
            intakes: data.data.intakes,
            linkedLeads: data.data.linkedLeads,
            recordings: data.data.recordings || [],
            // url: data.data.url,
            dataLoaded: true,
          };
          console.log(responseStateData)
          self.setState(responseStateData);
        }
      }).catch((error) => {
      console.log(error);
    });
  }


  closeMe() {
    this.setState({
      lmsId: null,
      open: false,
      dataLoaded: false,
      notes: [],
      formData: {},
      sweepstakes: [],
      documents: [],
      intakes: [],
      recordings: [],
      linkedLeads: [],
      activeTab: "1",
      highlightErrors: {},
    });
  }

  convertstorage() {
    const self = this;
    // postData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/storageconvert`, {}, this.props.token)
    //   .then((data) => {
    //     // console.log(data);
    //     if (data.status === "Success") {
    //       self.getDBConstants();
    //     }
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
  }

  delete() {
    const self = this;
    deleteData(`lms/${self.state.lmsId || 0}`, {})
      .then((data) => {
        if (data.status === "Success") {
          EventClient.emit("LMS_LIST_RELOAD");
          self.closeMe();
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  save(edit = false) {
    const payload = this.state.formData || {};
    //console.log(payload);
    if (!payload['homeemail'] && !payload['homephone'] && !payload['cellphone']) {
      toast.error("Please enter a home/cell phone number or home email");
      return;
    }
    if (!this.state.lmsId) {
      this.quickLookup([payload['homeemail'], payload['homephone'], payload['cellphone']], (totalResults) => {
        if (totalResults > 0) {
          EventClient.emit("CONFIRM_DIALOG", {
            message: "This lead may be a duplicate. Are you sure you want to save?",
            onOk: () => {
              this.saveInternal(edit, payload);
            },
            onCancel: () => undefined
          });
        } else {
          this.saveInternal(edit, payload);
        }
      });
    } else {
      this.saveInternal(edit, payload);
    }
  }

  saveInternal(edit, payload) {
    // return cb(null);
    const self = this;
    postData(!this.state.lmsId ? `lms/${this.state.formData.fid || 1}/add` : `lms/${this.state.lmsId || 0}/save`, payload)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {

          if (edit && data.data.id) {
            EventClient.emit("LMS_ENTRY_EDIT", data.data.id);
            EventClient.emit("LMS_LIST_RELOAD");
          } else {
            EventClient.emit("LMS_LIST_RELOAD");
            self.closeMe();
          }

        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  quickLookup(values, cb) {
    const self = this;
    const searchData = {
      q: values.map((value) => (value || "").trim()).join(" ").replace(/\s+/g, " "),
      page: 1,
      limit: 10
    };
    getData("lms/leads", searchData)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          //   data: data.data.leads,
          let totalResults = Number(data.data.results);
          cb(totalResults);
        } else {
          toast.error("Could not compare to other leads");
        }
      })
      .catch(error => {
        toast.error("Could not compare to other leads");
        console.error(error);
      });
  }

  quickFieldCheck(field, formData, self) {
    if (this.state.lmsId) return;
    if (field === "homeemail" || field === "homephone" || field === "cellphone") {
      let value = formData[field];
      if (value && value.length > 0) {
        self.quickLookup([value], (totalResults) => {
          if (totalResults > 0) {
            self.setState({
              highlightErrors: {
                ...self.state.highlightErrors,
                [field]: true
              }
            });
          } else {
            self.setState({
              highlightErrors: {
                ...self.state.highlightErrors,
                [field]: false
              }
            });
          }
        });
      } else {
        self.setState({
          highlightErrors: {
            ...self.state.highlightErrors,
            [field]: false
          }
        });
      }
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    if (!this.state.open) return null;
    const containerStyle = {
      zIndex: 1999
    };
    let portalStatus = this.portalStatus(this.state.formData);
    return (
      <MakeDialog isOpen={this.state.open}
                  header="Lead"
                  footer={(
                    <Fragment>
                      {!this.state.hideButtons && (
                        <Fragment>

                          {hasPermission(RequiredPermission.LMSSave) && (
                            <Fragment>
                              <Button color="primary"
                                      onClick={() => this.save()}>Save</Button>
                              {!this.state.lmsId && (
                                <Button color="info"
                                        onClick={() => this.save(true)}>Save and Edit</Button>
                              )}
                            </Fragment>
                          )}
                          {checkPerms(this.props.perms, RequiredPermissions.LMSRemove) && (
                            <Button color="danger"
                                    onClick={() => {
                                      const self = this;
                                      EventClient.emit("CONFIRM_DIALOG", {
                                        message: "This will delete the lead from the system. Are you sure?",
                                        onOk: () => {
                                          self.delete();
                                        },
                                        onCancel: () => undefined
                                      });
                                    }}>Delete</Button>
                          )}
                          <Button color="secondary"
                                  onClick={() => this.closeMe()}>Close</Button>
                        </Fragment>
                      )}
                    </Fragment>
                  )}>
        {!this.state.dataLoaded ?
          <Fragment>Loading
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </Fragment>
          :


          <Fragment>
            <Nav tabs style={{cursor: "pointer"}}>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === '1'})}
                  onClick={() => this.toggleTab('1')}>
                  General
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === '2'})}
                  onClick={() => this.toggleTab('2')}>
                  Military
                </NavLink>
              </NavItem>

              {this.state.lmsId > 0 && (
                <Fragment>
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '3'})}
                      onClick={() => this.toggleTab('3')}>
                      Notes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '4'})}
                      onClick={() => this.toggleTab('4')}>
                      Documents
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '9'})}
                      onClick={() => this.toggleTab('9')}>
                      Client Portal
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '5'})}
                      onClick={() => this.toggleTab('5')}>
                      Sweepstakes
                    </NavLink>
                  </NavItem>
                  {/*<NavItem>*/}
                  {/*  <NavLink*/}
                  {/*    className={classnames({active: this.state.activeTab === '6'})}*/}
                  {/*    onClick={() => this.toggleTab('6')}>*/}
                  {/*    Briefcase Links*/}
                  {/*  </NavLink>*/}
                  {/*</NavItem>*/}
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '7'})}
                      onClick={() => this.toggleTab('7')}>
                      Intakes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '8'})}
                      onClick={() => this.toggleTab('8')}>
                      Linked Leads
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '10'})}
                      onClick={() => this.toggleTab('10')}>
                      Emails
                    </NavLink>
                  </NavItem>
                  {hasPermission(RequiredPermissions.CameraListAll) && (
                    <NavItem>
                      <NavLink
                        className={classnames({active: this.state.activeTab === '11'})}
                        onClick={() => this.toggleTab('11')}>
                        Recordings
                      </NavLink>
                    </NavItem>
                  )}

                </Fragment>
              )}

            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Col lg={3} md={6}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="status">Ins Status</Label>
                      <Input
                        type="select"
                        id="status"
                        value={getFormFieldValue(this.state.formData['status'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      >
                        <option key={0} disabled={true} value={""}>Please Choose</option>
                        {getLMSStatusList([0, 1]).map((status, index) => {
                          return (
                            <option key={index} value={status.id}>{status.display}</option>
                          )
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col lg={3} md={6}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="dcStatus">Debt Status</Label>
                      <Input
                        type="select"
                        id="dcStatus"
                        value={getFormFieldValue(this.state.formData['dcStatus'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      >
                        <option key={0} disabled={true} value={""}>Please Choose</option>
                        {getLMSStatusList(2).map((status, index) => {
                          return (
                            <option key={index} value={status.id}>{status.display}</option>
                          )
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup check className="form-check-inline form-group-condensed"
                               style={{}}>
                      <Label check htmlFor="blacklist">
                        <Input type="checkbox" id="blacklist"
                               value="blacklist"
                               disabled={!hasPermission(RequiredPermission.LMSBlacklist)}
                               checked={getFormFieldValue(this.state.formData["blacklist"]) === 1}
                               onChange={(evt) => formsDataUpdater(evt.target.id, evt.target.checked ? 1 : 0, this.state.formData, this, () => {
                               })}/>
                        Blacklisted
                      </Label>
                    </FormGroup>
                    <FormGroup check className="form-check-inline form-group-condensed"
                               style={{}}>
                      <Label check htmlFor="stop">
                        <Input type="checkbox" id="stop"
                               value="stop"
                               checked={getFormFieldValue(this.state.formData["stop"]) === 1}
                               onChange={(evt) => formsDataUpdater(evt.target.id, evt.target.checked ? 1 : 0, this.state.formData, this, () => {
                               })}/>
                        STOP SMS/Email
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <div id={"folderPath"} style={{display: "flex", fontSize: 11}}>
                  Path: /{this.state.formData.folderPath}
                  <a href="javascript:void(0)"
                     onClick={() => this.setState({showFolderSelection: true})}
                     style={{marginLeft: 10}}
                  >Change</a>
                </div>
                <Row>
                  <Col sm={12}>
                    <FormGroup check className="form-check-inline form-group-condensed"
                               style={{float: "right"}}>
                      <Label check htmlFor="maritalstatus">
                        <Input type="checkbox" id="maritalstatus"
                               value="married"
                               checked={getFormFieldValue(this.state.formData["maritalstatus"]) === "Married"}
                               onChange={(evt) => formsDataUpdater(evt.target.id, evt.target.checked ? "Married" : "Single", this.state.formData, this, () => {
                               })}/>
                        Married
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6} xs={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="fname">Member First</Label>
                      <Input
                        type="text"
                        id="fname"
                        value={getFormFieldValue(this.state.formData['fname'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="mname">Middle</Label>
                      <Input
                        type="text"
                        id="mname"
                        value={getFormFieldValue(this.state.formData['mname'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="lname">Last</Label>
                      <Input
                        type="text"
                        id="lname"
                        value={getFormFieldValue(this.state.formData['lname'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>

                  {getFormFieldValue(this.state.formData["maritalstatus"]) === "Married" && (
                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="spfname">Spouse First</Label>
                        <Input
                          type="text"
                          id="spfname"
                          value={getFormFieldValue(this.state.formData['spfname'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="spmname">Middle</Label>
                        <Input
                          type="text"
                          id="spmname"
                          value={getFormFieldValue(this.state.formData['spmname'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="splname">Last</Label>
                        <Input
                          type="text"
                          id="splname"
                          value={getFormFieldValue(this.state.formData['splname'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col lg={8} md={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="address1">Address 1</Label>
                      <Input
                        type="text"
                        id="address1"
                        value={getFormFieldValue(this.state.formData['address1'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="address2">Address 2</Label>
                      <Input
                        type="text"
                        id="address2"
                        value={getFormFieldValue(this.state.formData['address2'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="city">City</Label>
                      <Input
                        type="text"
                        id="city"
                        value={getFormFieldValue(this.state.formData['city'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={4} md={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="state">State</Label>
                      <Input
                        type="text"
                        id="state"
                        value={getFormFieldValue(this.state.formData['state'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="zip">Zip</Label>
                      <Input
                        type="text"
                        id="zip"
                        value={getFormFieldValue(this.state.formData['zip'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={6} sm={12} xs={12}>
                    <FormGroup>
                      <Label for="cellphone">Cell Phone</Label>
                      <Input
                        type="text"
                        id="cellphone"
                        value={getFormFieldValue(this.state.formData['cellphone'])}
                        onChange={(evt) => formsDataUpdater("cellphone", evt.target.value.replace(/[^0-9]/g, ''), this.state['formData'], this)}
                        valid={!this.state.highlightErrors['cellphone']}
                        onBlur={() => this.quickFieldCheck('cellphone', this.state.formData, this)}
                      />
                      {this.state.highlightErrors['cellphone'] && (
                        <span style={{color: "red"}}>Duplicate Detected</span>)}
                    </FormGroup>
                  </Col>
                  <Col lg={4} md={6} sm={12} xs={12}>
                    <FormGroup>
                      <Label for="homephone">Home Phone</Label>
                      <Input
                        type="text"
                        id="homephone"
                        value={getFormFieldValue(this.state.formData['homephone'])}
                        onChange={(evt) => formsDataUpdater("homephone", evt.target.value.replace(/[^0-9]/g, ''), this.state['formData'], this)}
                        valid={!this.state.highlightErrors['homephone']}
                        onBlur={() => this.quickFieldCheck('homephone', this.state.formData, this)}
                      />
                      {this.state.highlightErrors['homephone'] && (
                        <span style={{color: "red"}}>Duplicate Detected</span>)}
                    </FormGroup>
                  </Col>
                  <Col lg={4} md={6} sm={12} xs={12}>
                    <FormGroup>
                      <Label for="homeemail">Home Email
                        {this.state.formData.homeemail && this.state.formData.homeemail.length > 0 && (
                          <Button
                            style={{padding: "0 5px", margin: 0, marginLeft: 10, verticalAlign: "unset", border: 0}}
                            onClick={() => this.sendCPEmail()}
                          >Send CP Link</Button>
                        )}
                      </Label>
                      <Input
                        type="text"
                        id="homeemail"
                        value={getFormFieldValue(this.state.formData['homeemail'])}
                        onChange={(evt) => formsDataUpdater("homeemail", evt.target.value, this.state['formData'], this)}
                        valid={!this.state.highlightErrors['homeemail']}
                        onBlur={() => this.quickFieldCheck('homeemail', this.state.formData, this)}
                      />
                      {this.state.highlightErrors['homeemail'] && (
                        <span style={{color: "red"}}>Duplicate Detected</span>)}
                    </FormGroup>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="branch">Branch</Label>
                      <Input
                        type="text"
                        id="branch"
                        value={getFormFieldValue(this.state.formData['branch'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="rank">Rank</Label>
                      <Input
                        type="text"
                        id="rank"
                        value={getFormFieldValue(this.state.formData['rank'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="rate">Rate</Label>
                      <Input
                        type="text"
                        id="rate"
                        value={getFormFieldValue(this.state.formData['rate'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="command">Command</Label>
                      <Input
                        type="text"
                        id="command"
                        value={getFormFieldValue(this.state.formData['command'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="separation">ETS/DOS Date</Label>
                      <Input
                          type="date"
                          id="separation"
                          placeholder="date"
                          value={getFormFieldValue(this.state.formData['separation']).split("T")[0] || ""}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="dutystatus">Duty Status</Label>
                      <Input
                        type="text"
                        id="dutystatus"
                        value={getFormFieldValue(this.state.formData['dutystatus'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="dutyphone">Duty Phone</Label>
                      <Input
                        type="text"
                        id="dutyphone"
                        value={getFormFieldValue(this.state.formData['dutyphone'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="dutyemail">Duty Email</Label>
                      <Input
                        type="text"
                        id="dutyemail"
                        value={getFormFieldValue(this.state.formData['dutyemail'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={3}>
                    <FormGroup check className="form-check-inline form-group-condensed"
                               style={{}}>
                      <Label check htmlFor="retired">
                        <Input type="checkbox" id="retired"
                               value="retired"
                               checked={getFormFieldValue(this.state.formData["retired"]) === 1}
                               onChange={(evt) => formsDataUpdater(evt.target.id, evt.target.checked ? 1 : 0, this.state.formData, this, () => {
                               })}/>
                        Retired
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{marginTop: 15}}>
                  <Col md={6} sm={6}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="source">Lead Source</Label>
                      <Input
                        type="text"
                        id="source"
                        value={getFormFieldValue(this.state.formData['source'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="3">
                <NotesTab notes={this.state.notes}
                          lmsId={this.state.lmsId}
                          onAddMode={(mode) => this.setState({hideButtons: mode})}
                          onUpdate={(notes) => this.setState({notes})}
                />
              </TabPane>
              <TabPane tabId="4">
                <DocumentsTab documents={this.state.documents}
                              lmsId={this.state.lmsId}
                              onUpdate={(documents) => this.setState({documents})}
                />
              </TabPane>
              <TabPane tabId="5">
                <Row>
                  <Col lg={4} md={6}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="sweepContest">Sweepstakes</Label>
                      <Input
                        type="select"
                        id="sweepContest"
                        value={getFormFieldValue(this.state.formData['sweepContest'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      >
                        {this.state.sweepstakes.map((stake, index) => {
                          return <option key={index} value={stake.id}>{stake.display}</option>
                        })}
                      </Input>
                    </FormGroup>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="sweepEntries"># Entries</Label>
                      <Input
                        type="number"
                        id="sweepEntries"
                        value={getFormFieldValue(this.state.formData['sweepEntries'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="sweepAttemptsLeft">Attempts Left</Label>
                      <Input
                        type="number"
                        id="sweepAttemptsLeft"
                        value={getFormFieldValue(this.state.formData['sweepAttemptsLeft'])}
                        onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="6">
              </TabPane>
              <TabPane tabId="7">
                <IntakesTab intakes={this.state.intakes}/>
              </TabPane>
              <TabPane tabId="8">
                <LinkedLeadsTab lmsId={this.state.lmsId || 0}
                                linkedLeads={this.state.linkedLeads}
                                onUpdate={(newLeads) => {
                                  this.setState({linkedLeads: newLeads})
                                }}
                />
              </TabPane>
              <TabPane tabId="9">
                <Row>
                  <Col md={12} sm={12}>
                    <FormGroup className={"form-group-condensed"}>
                      <Label for="branch">Portal Status</Label>
                      <span style={{marginLeft: 10, fontWeight: "bold"}}>{portalStatus}</span>
                    </FormGroup>
                  </Col>
                </Row>
                {portalStatus !== "Not Registered" && (
                  <Fragment>
                    <Row>
                      <Col md={12} sm={12}>
                        <FormGroup className={"form-group-condensed"}>
                          <Label for="branch">Login Email</Label>
                          <Input
                            type="text"
                            readOnly
                            id="branch"
                            value={getFormFieldValue(this.state.formData['login'])}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      {portalStatus === "Active - Password Reset Requested" && (
                        <Col xs={6}>
                          <Button onClick={() => {
                            this.clearTempCode(this.state.formData['id']);
                          }}>Clear Temp Code</Button>
                        </Col>
                      )}

                      <Col xs={6}>
                        <Button onClick={() => {
                          this.clearAccountLogin(this.state.formData['id']);
                        }}>Clear Account Details</Button>
                      </Col>
                    </Row>
                  </Fragment>
                )}
                <Row>
                  <Col>
                    <p>Helper Text</p>
                    <span>{this.portalStatusHelp(portalStatus)}</span>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="10">
                <Button onClick={() => this.sendEmail(1)}>Send Satisfaction</Button>
              </TabPane>
              <TabPane tabId="11">
                {this.state.recordings && this.state.recordings.length > 0 && (
                  <RecordingsTab recordings={this.state.recordings}/>
                )}
              </TabPane>
            </TabContent>
            {this.state.showFolderSelection && (
              <LMSFolderSelection show={true}
                                  defaultFolder={this.state.formData.fid || 0}
                                  copyOrMove={"move"}
                                  onSave={(fid, folderPath) => this.onFolderSave(fid, folderPath)}
                                  onCancel={() => this.setState({showFolderSelection: false})}/>
            )}
          </Fragment>
        }
      </MakeDialog>
    )
  }

  portalStatus(lead) {
    if (!lead || !lead.id) return "";
    if (lead.clientstatus === 2 && !lead.tcode) return "Active";
    if (lead.clientstatus === 2 && lead.tcode && lead.tcode.length > 0) return "Active - Password Reset Requested";
    if (lead.tcode && lead.tcode.length > 0) return "Waiting for Validation Code Input";
    if (typeof lead.tcode === "string" && lead.tcode.length === 0 && lead.clientstatus === 0 && lead.login) return "Waiting for Password Input";
    return "Not Registered";
  }

  portalStatusHelp(statusText) {
    switch (statusText) {
      case "Active":
        return "If user is having issues, make sure they are using the correct email and have them use it with forgot password option.";
      case "Active - Password Reset Requested":
        return "User has account but used the forgot password option and is waiting for email validation code.";
      case "Waiting for Validation Code Input":
        return "User filled out register form and is waiting for the validation code to be emailed to them. If they never received it, confirm the email showing above is actually the one they are using or no typo. BE WARE OF SCAMMERS";
      case "Waiting for Password Input":
        return "User registered and validated their email and have not entered a password yet. Have user try the forgot password option or delete client account and have them re-register.";
      case "Not Registered":
        return "LMS entry is not registered to a client portal login. Have user fill out register form with their home email.";
      default:
        return "";
    }
  }

  clearTempCode() {
    const self = this;
    EventClient.emit("CONFIRM_DIALOG", {
      message: "This will clear the Temporary Code on the Account and return the Status back to Active",
      onOk: () => {
        deleteData(`lms/${self.state.formData.id || 1}/tcode`, {})
          .then((data) => {
            // console.log(data);
            if (data.status === "Success") {
              EventClient.emit("LMS_ENTRY_EDIT", self.state.formData.id);
            }
          })
          .catch(error => {
            console.error(error);
          });

      },
      onCancel: () => undefined
    });
  }

  clearAccountLogin() {
    const self = this;
    EventClient.emit("CONFIRM_DIALOG", {
      message: "This will the Account Credentials and force the client to re-register.",
      onOk: () => {
        deleteData(`lms/${this.state.formData.id || 1}/client`, {})
          .then((data) => {
            // console.log(data);
            if (data.status === "Success") {
              EventClient.emit("LMS_ENTRY_EDIT", this.state.formData.id);
            }
          })
          .catch(error => {
            console.error(error);
          });
      },
      onCancel: () => undefined
    });
  }

  sendCPEmail() {
    let payload = {
      to: [this.state.formData.homeemail],
      lmsId: this.state.formData.id || 0,
    };
    postData(`lms/sendemail/clientcp`, payload)
      .then((data) => {
        if (data.status === "Success") {
          toast.success("Email sent successfully");
          // this.props.onClose && this.props.onClose(data.data.note);
        } else {
          toast.error(data.message);
          console.error(data);
        }
      })
      .catch((err) => {
        toast.error(`Error sending email: ${err.message}`);
        console.error(err);
      });
  }

  sendEmail(id) {
    let payload = {
      to: [this.state.formData.homeemail],
      lmsId: this.state.formData.id || 0,
    };
    postData(`templates/sendemail/${id}`, payload)
      .then((data) => {
        if (data.status === "Success") {
          toast.success("Email sent successfully");
          // this.props.onClose && this.props.onClose(data.data.note);
        } else {
          toast.error(data.message);
          console.error(data);
        }
      })
      .catch((err) => {
        toast.error(`Error sending email: ${err.message}`);
        console.error(err);
      });
  }

  onFolderSave(fid, folderPath) {
    this.setState({formData: {...this.state.formData, fid, folderPath}, showFolderSelection: false});
  }
}



// WEBPACK FOOTER //
// ./src/containers/Leads/modals/LMSEntryEditor.js